export enum EMessageType {
  TOKEN = 'TOKEN',
  READY = 'READY',
  // CB = CLAIMS_BOT
  CB_CLAIM_DETAILS = 'CB_CLAIM_DETAILS',
  CB_INITIAL_PROMPT = 'CB_INITIAL_PROMPT',
  CB_CLEAR_CHAT = 'CB_CLEAR_CHAT',
  CLOSE_IFRAME = 'CLOSE_IFRAME',
  // NB = NativeBridge
  NB_CALLBACK = 'NB_CALLBACK',
  OPEN_ARTICLE = 'OPEN_ARTICLE',
}

export enum EV3StreamEventType {
  TOOL_START = 'tool_start',
  TOOL_END = 'tool_end',
  RESPONSE_CHUNK = 'response_chunk',
  RESPONSE_COMPLETE = 'response_complete',
}

export interface IV3ToolData {
  tool_name: string;
  display_name: string;
}

export interface IV3StreamEvent {
  answer: string;
  type: EV3StreamEventType;
  tool_data?: IV3ToolData;
  conversation_id?: string;
  options?: OptionProps[];
  final_answer?: boolean;
  escalation?: boolean;
  source?: string;
  error?: {
    status_code?: number;
    code?: string;
    message?: string;
  };
}

export interface IV3ToolCall {
  tool_name: string;
  display_name: string;
  status: 'in_progress' | 'completed';
}

export interface IV3ThoughtState {
  isActive: boolean;
  isCollapsed: boolean;
  hasTools: boolean;
  toolCalls: IV3ToolCall[];
}

export enum ETicket{
  IS_MY_TREATMENT_COVERED_IMTC_AT = 'is_my_treatment_covered_imtc-at'
}

export enum EOptionAction {
  BOT_BUTTON = 'botButton',
  DEEP_LINK = 'deeplink',
  TICKET = 'ticket',
  STRAPI_ARTICLE_ID = 'strapiArticleId',
  PHONE = 'phone',
  BOT_MESSAGE = 'botMessage'
}

export enum EBotType {
  CASHLESS_GPT_V2 = 'cashlessgptv2',
  RTL_BOT = 'rtl_bot',
  DIABETEASE_BOT = 'diabetease_bot',
  CLAIMS_BOT = 'claims_bot',
  REIMBURSEMENT_CLAIMS_BOT = 'reimbursement-claims-bot',
  HEALTH_CHECKUP_BOT = 'health_checkup_bot',
  HEALTH_CHECKUP_SUPPORT_BOT = 'health_checkup_support_bot',
  POLICYGPTV2 = 'policygptv2',
  TELEHEALTH_BOT = 'telehealth_bot',
  TELEHEALTH_BOT_NC = 'telehealth_bot_nc',
  HEALTH_ID_BOT = 'health_id_bot',
  MANAGE_DEPENDENT_BOT = 'manage_dependent_bot',
  TELEHEALTH_SUPPORT_BOT = 'telehealth_support_bot',
  CASHLESS_SUPPORT_BOT = 'cashless_support_bot',
  CULT_SUPPORT_BOT = 'cult_support_bot'
}

export enum EArticleType {
  WHATS_COVERED_WHATS_NOT_COVERED = 'wcwnc'
}

export interface IUser {
  d2cUserId: string;
  memberId: string;
  organisationId: string;
  emailId: string;
  firstName: string;
  lastName?: string;
}

export interface IMessagePayload {
  type: EMessageType;
  data: Array<EMessageType> | string | object | boolean;
}

export interface IBotVariantConfig {
  variant: string;
  contextValues?: Record<string, string> | null;
  value?: (data: any) => any;
  BotPrompt?: React.FC<OptionsProps> | null;
  botPromptInitialOptions?: OptionProps[];
  getInitialMessage?: (payloadData?: TPayloadData) => string;
}

export type ITelehealthAppointment = {
  session_details: {  
  appointmentTime:string;
  id: string;
  patientName: string;
  statusBadge: ETelehealthAppointmentStatus;
  consultantName?: string;
  consultant: {
    firstName: string;
    lastName?: string;
    imageUrl: string;
    specialities: string;
    consultationRefNum:string;
    gender:string;
    experienceInYears:string;
  };
  isPrescriptionAvailable:boolean;
  state:string;
  status:string;
  patientRelation:string;
  patientGender:string;
  rating:{
    rating: number | string;
    count: number | string;
  }
  feedback:{
    comment: string;
    consultantRating:string;
    videoExpRating:string;
  }
  isCallStarted:boolean;
  isDoctorJoined:boolean;
  isPatientJoined:boolean;
  slot: {
    slotDateTime: string;
    endTime:string;
  };
  reasonForConsultation:string;
  startOfPracticeYear: string | number;
  }
};

export type TPayloadData = IClaimsPayloadData & ITelehealthAppointment & { healthCheckupBooking?: IHealthCheckupBooking } & { memberships?: { memberName?: string } } & { telehealth?: { current_consultation?: { patientName?: string; consultantName?: string; appointmentTime?: string } } } & { cashless_claim?: { current_claim?: { plumClaimId?: string; memberName?: string; status?: string } } };

export interface IContextValues {
  key: string;
  value: any;
}

export interface AskMeAnythingProps {
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  query: string;
  handleInputChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isSubmitEnabled: string;
  isStreaming: boolean;
}

export interface OptionProps {
  actionType: EOptionAction;
  title: string;
  content?: string;
  articleType?:string;
  master_category_tag?:string;
}

export interface QueryResponse {
  id: number;
  query: string;
  response: string;
  feedbackGiven: boolean;
  cid: string;
  date: Date;
  actionType?: string;
  content?: string;
  articleType?: string;
  isV3Response?: boolean;
  v3ThoughtState?: IV3ThoughtState;
  isV3Streaming?: boolean;
}

export interface IbotError {
  botName: string | undefined;
  payloadData: any;
  queryIdRef: React.MutableRefObject<number>;
  setResponses: React.Dispatch<React.SetStateAction<QueryResponse[]>>;
  setOptionClicked: React.Dispatch<React.SetStateAction<boolean>>;
  statusCode?:number;
  code?:string;
  message?:string
}

export enum ETelehealthAppointmentStatus {
  WAITING_FOR_DOCTOR = 'WAITING FOR DOCTOR',
  ONGOING = 'ONGOING',
  WAITING_FOR_PATIENT = 'WAITING FOR PATIENT',
  WAITING_FOR_PRESCRIPTION = 'WAITING FOR PRESCRIPTION',
  CANCELLED = 'CANCELLED',
  APPOINTMENT_FAILED = 'APPOINTMENT FAILED',
  CONFIRMED = 'CONFIRMED',
  COMPLETED = 'COMPLETED',
}

export type ISuperTopupProposedMember = {
  id: string;
  name: string;
  relationship: 'father' | 'mother' | 'son' | 'daughter' | 'self' | 'spouse';
  dateOfBirth: string;
  gender: 'male' | 'female';
};

export type ISuperTopupPolicy = {
  sumInsured: number;
  policyId: string;
  policyType?: 'INDIVIDUAL' | 'FAMILYFLOATER';
  id: string;
  proposedMembers: ISuperTopupProposedMember[];
};

export type IClaimTypeOfCare =
  | 'OPD'
  | 'Home Care'
  | 'DayCare'
  | 'IPD'
  | 'PrePost';

export type IClaimStatus =
  | 'IN PROCESS'
  | 'APPROVED'
  | 'REJECTED'
  | 'PAUSED'
  | 'NOT APPLICABLE'
  | 'IN DRAFTS'
  | 'REQUEST RECEIVED';

export type ITypeOfClaim =
  | 'Emergency'
  | 'Reimbursement'
  | 'Planned'
  | 'Cashless'
  | 'All';

export type IClaim = {
  typeOfClaim: ITypeOfClaim;
  plumClaimId: string;
  typeOfCare: IClaimTypeOfCare;
  memberName: string;
  memberId: string;
  patientRelationship: string;
  patientName: string;
  createdAt: string;
  uiRepresentation: {
    typeOfCare: {
      value: string;
    };
    typeOfClaim: {
      value: string;
    };
    status: {
      valueCaps: IClaimStatus;
    };
  };
};

export type IMetaContent = {
  txnType: string;
  appointments?: ITelehealthAppointment[];
  policies?: ISuperTopupPolicy[];
  claims?: IClaim[];
  path: string;
  mixpanelArticleId: string;
  mixpanelCategory: string;
  mixpanelNodeId: string;
  mixpanelSubcategory: string;
};

export interface FeedbackOption {
  actionType: string;
  content: string;
  title: string;
}

export interface IClaimsPayloadData {
  uiRepresentation: {
    status: {
      value: string;
    };
  };
  plumClaimId: string;
  stage: string;
  memberName: string;
}

export interface IHealthCheckupBooking {
  bookingId: string;
  customerBookingId: string;
  statusDetail: {
    enumVal: string;
    value: string;
    text: string;
    description: string;
    color: string;
  };
  packageDetails: {
    id: string;
    name: string;
    icon: string;
  };
  patientName: string;
  appointmentDateTimeDetails: {
    fullDate: string;
    epochTime: number;
    weekDay: string;
    month: string;
    date: number;
    year: number;
    fullTime: string;
  };
  orderId: string;
}

export interface OptionsProps {
  isDisabled?:boolean;
  options: OptionProps[];
  conversationId: string;
  setOptionClicked: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  setQuery: (query: string) => void;
  getAnswer: (messages: string, queryId: number) => Promise<string | undefined>;
}

export interface BotMessageOptionProps {
  isDisabled?:boolean;
  title: string;
  handleButtonClick: () => void;
  setOptionClicked?: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IDocument {
  documentId: string;
  name: string;
  previewUrl: { '64': string; preview?: string };
  url: string;
  sectionTag: string;
  createdAt: string;
  attrs: Record<string, string | number>;
  verification?: IDocumentVerification;
  timeSinceUploadText?: string;
  preFilled?: boolean;
}

export enum EDocumentVerificationStatus {
  IN_PROCESS = 'in-process',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  ERROR = 'error',
}

export interface IDocumentVerification {
  status: EDocumentVerificationStatus;
  errorMessage: string;
}

export interface IRenderFormInputField {
  categoryId: string;
  label: string;
  maxTextLength: number;
  name: string;
  order: string;
  placeholder: string;
  title: string;
  type: string;
  value: string;
  variableName: string;
  regex?: string;
  hint?: string;
  confirmField?: string;
  capitalise?: string;
  maskCharacters?: string;
  sectionTag: string;
  fieldUrl?: string;
  disabled?: boolean;
}

export enum EClaimStages {
  OPEN_LEAD = 'open-lead',
  QUALIFIED_LEAD = 'qualified-lead',
  SETTLED = 'settled',
  PRE_AUTH_REJECTED = 'pre-auth-rejected',
  FINAL_SETTLEMENT_REJECTED = 'final-settlement-rejected',
  DISQUALIFIED_LEAD = 'disqualified-lead',
}

export interface ICategory {
  categoryId: string;
  subtitle: string;
  title: string;
  uiorder: number;
  page: number;
}

export interface ISampleDocument {
  downloadButtonText: string;
  title: string;
  url: string;
}

export interface IUpload {
  buttonText: string;
  hint: string;
}

export interface IInstruction {
  instructionList: Array<{ text: string; heading: string; iconUrl: string }>;
  dosList: Array<{ text: string }>;
  dontsList: Array<{ text: string }>;
  iconUrl: string;
  instructionPopupSeenFlag: boolean;
  subtitle: string;
  title: string;
}

export interface IDocumentsRequiredContent {
  allowedFileTypes?: Array<string>;
  category: ICategory;
  emailTitle?: string;
  hint?: string;
  maxFileSizeMB?: number;
  minFileSizeMB?: number;
  required: boolean;
  sampleDocuments: Array<ISampleDocument>;
  sectionTag: string;
  title: string;
  subtitle?: string;
  upload: IUpload;
  forms: Array<any>;
  instructions: IInstruction;
  hasToBeVerified?: boolean;
}

export interface IStatusPageContent {
  statusPageContent: { highlight: string; list: string };
}

export interface IStatusHighlight {
  background: string;
  linkText: string;
  redirectTo: string;
  subtitle: string;
  title: string;
}

export interface IStatusListItem {
  eventDate: string;
  flag: string;
  iconUrl: string;
  stage: string;
  subtitle: string;
  subtitle2: string;
  textColor: string;
  title: string;
  type: string;
}

export interface ICourierDetail {
  iconUrl: string;
  label: string;
  text: string;
}

export interface IArticleMeta {
  collectionName: string;
  id: string;
  coverImageUrl?: string;
  title: string;
  contentTypeDescription: string;
  contentTypeIconUrl: string;
  contentLengthDescriptionText: string;
  contentLengthFontColor: string;
  contentLengthBgColor: string;
}

export interface ICashlessStatusContent {
  AIClaimBuddyPromptList: Array<{ text: string }>;
  callbackIssueList: Array<any>;
  thingsToKeepInMind: Array<IArticleMeta>;
  timeline: Array<ICashlessTimelineItem>;
  customerSupportNumber: string;
}

export interface ICTA {
  type: string;
  text: string;
  deeplink: string;
  onClick?: any;
  disabled?: boolean;
  loading?: boolean;
}

export interface ICashlessTimelineItem {
  CTA: ICTA;
  completionTATTime: string;
  descriptionHTML: string;
  lateDescriptionHTML?: string;
  eventTime: string;
  stage: string | EClaimStages;
  stageType: 'red' | 'green';
  status: 'done' | 'pending';
  title: string;
  terminalStage?: boolean;
}

export interface IUiRepresentation {
  latestUpdate: {
    text: string;
    value: string;
  };
  status: {
    colorBackground: string;
    value: string;
    valueCaps?: string;
  };
}

export interface IClaimDetails {
  nextExpectedStageDate: string | Date;
  nextExpectedStage: string | Date;
  insurerRejectionReason: string;
  fullfilled: any;
  previouslyUploadedDocuments?: Array<{
    documents: Array<IDocument>;
    title: string;
    subtitle: string;
    uiorder: number;
  }>;
  digitisationInputFields: Array<IRenderFormInputField>;
  stage: string | EClaimStages;
  dateOfAdmission: string;
  dateOfDischarge: string;
  patientName: string;
  hospital: {
    hospitalname: string;
  };
  canDelete: boolean;
  typeOfCare: string;
  reasonForHospitalization: string;
  memberName: string;
  redirectTo: string;
  note: string;
  noteSourceText: string;
  documentsRequiredContentPreScript?: string;
  documents: Array<IDocument>;
  documentsRequiredContent: Array<IDocumentsRequiredContent>;
  amount: number | string;
  amountApproved: number | string;
  uploadDocsCompletedPage?: number;
  documentsUpdateRequestedCounter?: number;
  queryRaisedCounter: number;
  reviewDetails?: {
    DURFeedback: Array<{ categoryNotes: Record<string, string> }>;
  };
  leadRejectionReasonType?: string;
  finalSettlementRejectionReasonType?: string;
  preAuthRejectionReasonType?: string;
  approvedLetterURL?: string;
  settlementLetterURL?: string;
  patientId: string;
  memberId: string;
  typeOfClaim: string;
  plumClaimId: string;
  patientRelationship: string;
  expected?: Record<
    EClaimStages,
    {
      date: string;
    }
  >;
  statusContent?: {
    courierPendingContent: IStatusHighlight;
    contentVariables: {
      courierAddress: string;
    };
    statusPageContent: {
      courierDetails: Array<ICourierDetail>;
      highlight: IStatusHighlight;
      list: Array<IStatusListItem>;
    };
    cashlessStatusPageContent?: ICashlessStatusContent;
  };
  insuranceProviderHandle: string;
  tpaName?: string;
  typeOfBenefit?: string;
  organisationBenefitId?: string;
  uiRepresentation: IUiRepresentation;
  reasonForConsulation: string;
  courierDetailPage?: {
    address: string;
    fields: Array<{
      type: string;
      label: string;
      placeholder: string;
      name: string;
    }>;
  };
  claimCourierPending: boolean;
  insurerClaimId: string;
  modeOfSubmission: string;
  isClosed: boolean;
  isClaimForDependent?: boolean;
  isClaimDigitised: boolean;
  isClaimPreDigitised?: boolean;
  nextAllowedStepSlug: string;
  documentsUploadPageContent: null;
  digitisationSuccessful: boolean;
}